module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-wrapper', {
    attrs: {
      "background": "/static/img/anniversary/page-start/bg.png"
    }
  }, [_c('img', {
    staticClass: "main-title ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-start/shape-1-new.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-button ani",
    attrs: {
      "swiper-animate-effect": "animate__pulse",
      "src": "/static/img/anniversary/page-start/shape-02.png"
    },
    on: {
      "click": _vm.handleButtonClick
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "brand-area ani",
    attrs: {
      "swiper-animate-effect": "animate__fadeIn",
      "src": "/static/img/anniversary/page-start/shape-3-new.png"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-001c3d14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageStart/index.vue
// module id = 1518
// module chunks = 8